import React from "react";
import { Field, reduxForm } from "redux-form";
import {database} from "../app-database";
import Modal from '../generalcomponets/modal-mobile';

class ContratoMediosForm extends React.Component{

	state = {
		contrato : "",
		isMobile: window.innerWidth <= 760,
		isModalOpened: false,
		mostrarContrato: false
	}

	handleWindowResize = () => {
		this.setState({ isMobile: window.innerWidth <= 760 });
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleWindowResize);
		const url = window.location.hash;
	
		if (url.includes("#!/registro-familiar")) {
			this.mostrarContrato = true;
		}
		window.addEventListener('resize', this.handleWindowResize);
	}

	componentWillMount = () => {
		window.removeEventListener('resize', this.handleWindowResize);

		var $this = this;
		database.ref("/documentacion/confidencialidad").once("value").then(function(data){
			$this.setState({ "contrato" : data.val() });  
		});
	}
	
	cancelar = () => {
		this.props.change("acepto", false);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: false }))();
	}
	
	aceptar = () => {
		this.props.change("acepto", true);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: true }))();
	}

	openModalParent = () => {
		const { isModalOpened } = this.state;

		if(isModalOpened){
			this.setState({ isModalOpened: false});
		}
		else{
			this.setState({ isModalOpened: true});
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false})
	}
	
	render() {
		const { isMobile } = this.state;
		const { handleSubmit } = this.props;

		return (
			<form onSubmit={handleSubmit}>

				{ (isMobile || this.mostrarContrato === true) &&
				<div className="contratos-wrap mt-10" style={{padding:'0px 15px'}}>
					<h3 className="title-contract">Términos y Condiciones del Uso de Medios Electrónicos.</h3>
					<div className="content-scroll">
						<div dangerouslySetInnerHTML={{__html: this.state.contrato}} className={"body-contract"}></div>
					</div>
				</div>
				}

				{ this.mostrarContrato === true &&
					<div className="datos-wrap">
						<div className="row btn-bottom">
							<div className="col-md-6 col-sm-6 col-xs-12">
								<button type="button" data-toggle="modal" data-target="#modal-mediosElectronicos" className="orange-rectangle disabled" 
									style={{"marginBottom":"10px","width":"134px"}}>Rechazar
								</button>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-12">
								<button type="button" onClick={this.aceptar} className="orange-rectangle disabled" style={{"width":"134px"}}>Aceptar</button>
							</div>
						</div>
					</div>
				}

				{ isMobile &&
				<div className="container margin-buttons-movile-contracts">
					<div className="row" >
						<div className="registro-button-container">
							<div className="col-md-12 col-sm-12 col-xs-12">
									<button type="button" onClick={this.aceptar} className="pure-material-button-contained btn-full-width">Acepto términos</button>
							</div>
						</div>
					</div>
					<div className="row" >
						<div className="registro-button-container" style={{marginTop: '10px'}}>
							<div className="col-md-12 col-sm-12 col-xs-12" style={{marginBottom: '30px'}}>
									<button type="button" onClick={this.openModalParent} className="pure-material-button-outlined-registro btn-full-width">No acepto términos</button>
							</div>
						</div>
					</div>
				</div>}

				<div className="modal fade" data-backdrop="static" data-keyboard="false" id="modal-mediosElectronicos" tabIndex="-1" role="dialog" aria-labelledby="modal-mediosElectronicos">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title orange-text" style={{"padding":"0px"}}>Lo sentimos</h4>
							</div>
							<div >
								<p>Al no aceptar los Términos y Condiciones de uso de Medios Electrónicos no es posible concluir tu registro.</p><br />
								<p>Si eliges la opción "Salir" se perderán todos los datos capturados.</p>
							</div>
							<div className="modal-footer">
								<div className="text-center aceptar-cancelar-btn mt-50">
									<a data-dismiss="modal">Regresar</a>
									<a data-dismiss="modal" onClick={this.cancelar}>Salir</a>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Adding a new modal only for mobile */}
				{this.state.isMobile && this.state.isModalOpened &&
					<Modal closeModalFromChild={() => null}>
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
									<label className="gnp-material-title-modal">Lo Sentimos</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
									<p className=" gnp-material-content-modal">Al no aceptar los Términos y Condiciones de uso de Medios Electrónicos no es posible concluir tu registro.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
									<p className=" gnp-material-content-modal">Si eliges la opción "Salir" se perderán todos los datos capturados.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center">
									<button type="button" onClick={this.cancelar} className="pure-material-button-contained btn-full-width">Salir</button>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.closeModalFromChild} className="pure-material-button-outlined btn-full-width">Regresar</button>
								</div>
							</div>
						</div>
					</Modal>
				}

				<Field name="acepto" component="input" type="hidden" />
			</form>
		);
	}
}
const redux = reduxForm({form: "contrato"});
export default ContratoMediosForm = redux(ContratoMediosForm);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/contrato-medios.frm.js